import { useLocation } from "react-router";
import { useHomepageSuggestions, ChatSuggestion } from "./use-homepage-suggestions";
import { useFlowDesignerSuggestions } from "./use-flow-designer-suggestions";

const HOMEPAGE_ROUTES = ["landing", "applications"];

function parseModule(pathname: string): { module: string | null } {
    const parts = pathname.split("/").filter(Boolean);
    return { module: parts[0] ?? null };
}

export function useContextualSuggestions(): ChatSuggestion[] {
    const { pathname } = useLocation();
    const { module } = parseModule(pathname);

    const isHomepage = HOMEPAGE_ROUTES.includes(module ?? "");
    const isFlowDesigner = module === "flow";

    const homepageSuggestions = useHomepageSuggestions(isHomepage);
    const flowDesignerSuggestions = useFlowDesignerSuggestions(isFlowDesigner);

    if (isHomepage) return homepageSuggestions;
    if (isFlowDesigner) return flowDesignerSuggestions;
    return [];
}
